export default "/shwstETH.ca5292b85a349c016742413405501a21.svg";